import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const GroupsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('groups.title')}></Common.Header>;
};

export default translate()(GroupsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/GroupsListHeader.js